import { ARCHIVE_LAST_USER_ALERT, ArchiveLastUserAlert } from './types';

export const archiveLastUserAlert = (): ArchiveLastUserAlert => ({
  type: ARCHIVE_LAST_USER_ALERT,
});

export default {};
